<template>
  <div>
    <t-loader :loading="isBusy"></t-loader>
    <div class="row">
      <div class="col-12">
        <div class="card mt-2">
          <div class="card-header">
            Transactions
            <br>
            <small>All transactions</small>
          </div>
          <div class="card-body">
            <b-table
                show-empty
                :responsive="true"
                :items="myProvider"
                :busy.sync="isBusy"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                ref="table"
            >

              <template v-slot:cell(status)="data">
                <span class="badge badge-pill text-capitalize" :class="'badge-'+data.item.class">{{
                    data.item.status
                  }}</span>
              </template>
              <template v-slot:cell(total)="data">
                {{ data.item.money | formatMoney }}
              </template>
              <template v-slot:cell(createdAt)="data">
                {{ formatDateTime(data.item.createdAt) }}
              </template>
              <template v-slot:cell(source)="data">
                <a v-if="data.item.sourcePopup === true" href="#" @click="viewSourceInfo(data.item)"
                   class="text-success">
                  {{ data.item.sourceDescription }}
                </a>
              </template>
            </b-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="my-table"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <b-modal size="lg" hide-header hide-header-close hide-footer body-class="p-0" id="source-info">
      <template #default="{ hide }">
        <button type="button" data-dismiss="modal" aria-label="Close" class="close position-absolute"
                style="top: 0; right: 0; z-index: 2; padding: 1rem;" @click="hide">
          <span aria-hidden="true">×</span>
        </button>
        <template v-if="modalSelection && modalSelection.withdrawal_id !== null">
          <streamlabs-table class="mb-0" :withdraw-id="modalSelection.withdrawalId" :title="`Streamlabs donations in Transaction #${modalSelection.id}`"></streamlabs-table>
        </template>
        <template v-else>
          No data available.
        </template>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'TransactionTable',
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      transactions: [],
      isBusy: false,
      modalSelection: null,
      defaultFields: [
        {key: 'id', label: '#'},
        {key: 'status', label: 'Status'},
        {key: 'service', label: 'Service'},
        {key: 'message', label: 'Message'},
        {key: 'total', label: 'Total'},
        {key: 'source', label: 'Source'},
        {key: 'createdAt', label: 'Created at'},
      ],
    };
  },
  computed: {
    fields() {
      return this.defaultFields;
    },
  },
  methods: {
    viewSourceInfo(item) {
      this.modalSelection = item;
      if (this.modalSelection) {
        this.$bvModal.show('source-info');
      }
    },
    timeSinceTimestamp(ts) {
      return moment(ts).fromNow();
    },
    formatDateTime(ts) {
      return moment(ts).format('YYYY-MM-DD hh:mm');
    },
    myProvider(ctx) {
      const url = `/services/transactions/resource?page=${ctx.currentPage}&size=${ctx.perPage}`;
      let promise = axios.get(url);

      return promise.then((response) => {
        const data = response.data.data;
        const meta = response.data.meta;
        this.currentPage = meta.current_page;
        this.totalRows = meta.total;
        this.transactions = data || [];

        return this.transactions;
      }).catch(error => {
        return [];
      });
    },
    refresh() {
      this.$nextTick(() => {
        this.$refs.table.refresh();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
